// src/data/cradleData.js

// 1. IMPORT GLOBAL MAG COLORS (Cheaper Pricing)
import { GLOBAL_COLORS_MAG } from '../config/globalSettings';

export const holsterData = {
  // --- BRANDS ---
  brands: [
    { id: "beretta", name: "Beretta" },
  ],

  // --- GUN MODELS ---
  guns: [
    { 
      id: "beretta_tomcat_30x", 
      brand_id: "beretta", 
      name: "Beretta Tomcat 30X", 
      quick_ship: true 
    },
  ],

  // --- OPTIONS ---
  hands: [ { id: "right", name: "Right Handed" }, { id: "left", name: "Left Handed" } ],
  
  lightbearing_options: [ { id: "no", name: "Non-Lightbearing" } ],

  // --- COLORS (Linked to Global MAG Pricing) ---
  colors: GLOBAL_COLORS_MAG,

  // --- MOUNTS ---
  mounts: [
    { 
      id: "dcc_mod4_1_5", 
      name: "DCC-MOD 4 Universal 1.5\" Belt Clip", 
      price: 0, 
      img_layer_mount: "/images/mounts/dcc_mod4_front.png", 
      description: "Standard height universal clip for 1.5 inch belts."
    },
    { 
      id: "dcc_mod4_1_75", 
      name: "DCC-MOD 4 Universal 1.75\" Belt Clip", 
      price: 0, 
      img_layer_mount: "/images/mounts/dcc_mod4175_front.png", 
      description: "Universal clip for 1.75 inch belts."
    }
  ],

  // --- BREAKTHROUGH ---
  breakthrough: [ 
    { id: "no", name: "No Thanks", price: 0 }, 
    { id: "solvent", name: "Breakthrough Military Grade Solvent", price: 8.95 },
    { id: "oil", name: "Breakthrough Battle Born High Purity Oil", price: 8.95 },
    { id: "lubricant", name: "Breakthrough Battle Born Pro Lubricant", price: 12.95 },
    { id: "bundle", name: "Breakthrough Clean Bundle", price: 16.00 }
  ],

  // --- WARRANTIES ---
  warranties: [ 
    { id: "30_day", name: "30 Day Mfg Warranty", price: 0 }, 
    { id: "lifetime", name: "Lifetime Warranty", price: 12.99 } 
  ]
};